
import Vue from "vue";
import Icon from './index.vue'
import {EIcons,TIcon} from '.'
import {codeStyleMixins} from '@/mixins' 

import Prewiew from '../preview/index.vue'

export default Vue.extend({
	data(){
		return {
			desc:`
type IconType = "home" | "success" | "close" | "error" | "warn" | "info" | "blog" | "code" | "about" 
| "wechat" | "email" | "github" | "qq" | "arrowUp" | "arrowDown" | "empty" | "chat"
interface props {
  type: IconType
}
			`
		}
	},
	components:{
		Icon,
		Prewiew
	},
	computed:{
		icons(){
			const types = Object.keys(EIcons)
			return types.map(t=>{
				return {type:t,label:EIcons[t as TIcon]}
			})
		}
	},
	mixins:[codeStyleMixins]
})
